import React, { Component } from "react";
import * as Mui from "@material-ui/core";
import { IconCheck, IconChevronDown } from "../svg";
import { withTranslation } from "react-i18next";

class MultipleFilter extends Component {
  render() {
    const { t } = this.props;
    return (
      <Mui.FormControl
        variant="outlined"
        className={`default-form-field tbl-filter-field search`}
      >
        <Mui.TextField
          select
          variant="outlined"
          InputProps={
            this.props.label
              ? {
                startAdornment: (
                  <Mui.InputAdornment position="start">{this.props.label}:</Mui.InputAdornment>
                ),
                endAdornment: (
                  <Mui.InputAdornment position="end"></Mui.InputAdornment>
                )
              }
              : null
          }
          onChange={this.props.onFilter}
          value={
            this.props.value
              ? this.props.value
              : this.props.displayEmpty
                ? ["all"]
                : []
          }
          SelectProps={{
            className: "svg-margin-top",
            multiple: true,
            renderValue: (selected) => (
              <>
                {selected?.map((value, index) => (
                  <span key={index}>
                    {this.props.displayEmpty
                      ? value === "all"
                        ? t("COMMON.ALL")
                        : this.props.options?.find((x) => x.id === value)?.[
                        "name"
                        ]
                      : this.props.options?.find((x) => x.id === value)?.[
                      "name"
                      ]}
                    {index + 1 < selected?.length ? ", " : ""}
                  </span>
                ))}
              </>
            ),
            MenuProps: {
              className: "select-dropdown",
              getContentAnchorEl: null,

              anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            },
            IconComponent: IconChevronDown,
          }}
        >
          {this.props.displayEmpty ? (
            <Mui.MenuItem disabled value="all">
              {t("COMMON.ALL")}
            </Mui.MenuItem>
          ) : null}

          {this.props.options?.map((option, i) => (
            <Mui.MenuItem key={i} value={option.id}>
              {option.name}{" "}
              <span className="icon-selected">
                <IconCheck />
              </span>
            </Mui.MenuItem>
          ))}
        </Mui.TextField>
      </Mui.FormControl>
    );
  }
}

export default withTranslation()(Mui.withWidth()(MultipleFilter));
